/** The type of the attribute so that it can be sorted and filtered. */
enum VariationAttributeType {
  Size = 'size',
  Color = 'color',
  Width = 'width'
}

export default VariationAttributeType;
